export const setupHiddenLinkText = function (): void {
  const links: NodeListOf<HTMLAnchorElement> = document.querySelectorAll('a[target="_blank"]');
  links.forEach((link: HTMLAnchorElement) => {
    link.insertAdjacentHTML('beforeend', "<span class='visuallyhidden'>opens in a new tab</span>");
  });
};
